import { css, styled } from '@mui/material';

import { sectionMessageTextListClasses } from './theme';

import type { SectionMessageTextListOwnerState, SectionMessageTextListProps } from './types';

const SectionMessageTextList = (props: SectionMessageTextListProps) => {
  const { items = [], className, style, ref, ...others } = props;

  const ownerState: SectionMessageTextListOwnerState = {
    ...props,
    items,
  };

  return (
    <SectionMessageTextListRoot
      ownerState={ownerState}
      className={className}
      style={style}
      ref={ref}
      {...others}
    >
      {items.map((item, index) => (
        <SectionMessageTextListItem key={index} ownerState={ownerState}>
          {item}
        </SectionMessageTextListItem>
      ))}
    </SectionMessageTextListRoot>
  );
};

export default SectionMessageTextList;

// Styled Components
const SectionMessageTextListRoot = styled('ul', {
  target: sectionMessageTextListClasses.root,
})<{ ownerState: SectionMessageTextListOwnerState }>(
  () => css`
    display: flex;
    flex-direction: column;
    list-style: none;
    margin: 0;
    padding: 0;
  `,
);

const SectionMessageTextListItem = styled('li', {
  target: sectionMessageTextListClasses.item,
})<{ ownerState: SectionMessageTextListOwnerState }>(
  ({ theme }) => css`
    position: relative;
    padding-left: 12px;
    ${theme.typography['label/regular/xs']};
    color: ${theme.color['text/weak/default']};
    word-break: break-all;

    b {
      font-weight: 700;
    }

    &::before {
      content: '•';
      position: absolute;
      left: 0;
      color: ${theme.palette.text.primary};
    }
  `,
);
